export const EmailTemplateIds = {
  ActionResetCountdownDaysDoctor: "d-4fe2f851712e486b833bf4bc721959e6",
  ReminderUploadFileDoctor: "d-51799ab55ddd46cbad2dc8a9debe54cf",
  ReminderFillQsPatient: "d-8eeea207680a4427be06d77c058beb86",
  IntroTrainingIntr25: "d-1875f5aabc40451ca54fc5cbf80d9c6c",
  ReminderTrainingIntr25: "d-84c1a9b937c44fb88c31fcf89e52c461",
  IntroAppAccessCtrl25: "d-77483aa40bdf4614b75585df6596e7e9",
  ActionNewIncidentAdmin: "d-8004867011aa4454aebcd2e28662db13",
  ActionDeletePatientAdmin: "d-5e7121d854ab41de9cdd9f2b12e14ef9"
};

export const EmailTemplateSubjects = {
  ActionNewIncidentAdmin: "Nueva incidencia registrada — Proyecto Diactive-1",
  ActionDeletePatientAdmin: "Paciente eliminado — Proyecto Diactive-1",
  ActionUploadedFileAdmin: "Archivo glucosa subido",
  ActionFilledQuestionnairesAdmin: "Cuestionarios completados",
  ActionIntr25CompletedFirstWorkoutAdmin: "Primer entrenamiento completado",
  ActionPostEvalCompletedAdmin: "Evaluación post completada — Proyecto Diactive-1",
  ActionSetPasswordUser: "Accede a Diactive-1",
  ActionResetCountdownDaysDoctor: "Actualización de días del participante — Proyecto Diactive-1",
  WelcomeDoctor: "¡Bienvenido/a al proyecto multicéntrico Diactive-1!",
  WelcomeIntr25: "¡Bienvenido/a al grupo Intervención del proyecto Diactive-1!",
  WelcomeCtrl25: "¡Bienvenido/a al grupo Control del proyecto Diactive-1!",
  WelcomeSuperUser: "¡Bienvenido/a a la modalidad de administrador/a de Diactive-1!",
  WelcomeAppTester: "¡Bienvenido/a a la modalidad de testeador/a de la aplicación Diactive-1!",
  AutoReminderFillQuestionnairesPatient: "¡Recordatorio! Todavía no has rellenado todos los cuestionarios del estudio — Proyecto Diactive-1",
  AutoReminderUploadGlucoseFileDoctor: "Revise si están disponibles los archivos de glucosa/insulina de uno de sus participantes",
  AutoReminderUploadGlucoseFilePreDoctor: "Revise si están disponibles los archivos de glucosa/insulina de uno de sus participantes",
  AutoReminderUploadGlucoseFileFollowUpDoctor: "¡Recordatorio! Sube los archivos del monitor continuo de glucosa y/o bomba de insulina a la página web — Proyecto Diactive-1",
  AutoReminder15DaysRemainingDoctor: "¡Quedan aproximadamente 15 días para la evaluación final! — Proyecto Diactive-1",
  AutoReminder15DaysRemainingPatient: "¡Quedan aproximadamente 15 días para la evaluación final! — Proyecto Diactive-1",
  AutoReminder7DaysRemainingDoctor: "¡Quedan aproximadamente 7 días para la evaluación final! — Proyecto Diactive-1",
  AutoReminder7DaysRemainingPatient: "¡Quedan aproximadamente 7 días para la evaluación final! — Proyecto Diactive-1",
  ReminderUploadFileDoctor: "Revise si están disponibles los archivos de glucosa/insulina de uno de sus participantes",
  ReminderFillQsPatient: "¡Recordatorio! Todavía no has rellenado todos los cuestionarios del estudio — Proyecto Diactive-1",
  IntroTrainingIntr25: "¡Enhorabuena, ya puedes empezar a entrenar utilizando la aplicación Diactive-1! — Proyecto Diactive-1",
  ReminderTrainingIntr25: "¡Recordatorio! Tu frecuencia de entrenamiento semanal está bajando. ¡Vuelve a entrenar, tú puedes! — Proyecto Diactive-1",
  IntroAppAccessCtrl25: "Acceso a la app (control)"
};

/** MUI `SvgIcon` color for mail delivery status (maps to CheckCircle / ErrorOutline in UI). */
export const MailDeliveryStatusIconVariant = {
  /** Handoff to recipient (e.g. delivered) — theme primary, typically blue. */
  Primary: "primary",
  /** Engagement / pipeline OK (e.g. opened, processed) — green. */
  Success: "success",
  Error: "error"
};

/**
 * SendGrid-style delivery event statuses -> Spanish copy and success/error semantics.
 * `allowsManualResolve`: admin can mark as resolved when delivery failed.
 */
export const MailDeliveryStatusDisplay = {
  open: {
    label: "Abierto",
    iconVariant: MailDeliveryStatusIconVariant.Success
  },
  delivered: {
    label: "Entregado",
    iconVariant: MailDeliveryStatusIconVariant.Primary
  },
  processed: {
    label: "Procesado",
    iconVariant: MailDeliveryStatusIconVariant.Primary
  },
  bounce: {
    label: "Rebotado",
    iconVariant: MailDeliveryStatusIconVariant.Error,
    allowsManualResolve: true
  },
  deferred: {
    label: "Entrega aplazada",
    iconVariant: MailDeliveryStatusIconVariant.Error,
    allowsManualResolve: true
  },
  drop: {
    label: "Descartado",
    iconVariant: MailDeliveryStatusIconVariant.Error,
    allowsManualResolve: true
  },
  blocked: {
    label: "Bloqueado",
    iconVariant: MailDeliveryStatusIconVariant.Error,
    allowsManualResolve: true
  }
};

const MAIL_DELIVERY_STATUS_ALIASES = {
  bounced: "bounce",
  dropped: "drop"
};

/**
 * Resolves raw `delivery.event.status` (or legacy strings) to label, icon variant, and manual-resolve flag.
 */
export const getMailDeliveryStatusDisplay = (rawStatus) => {
  const t = String(rawStatus ?? "").trim().toLowerCase();
  if (!t) {
    return { label: "", iconVariant: null, allowsManualResolve: false };
  }
  const canonical = MAIL_DELIVERY_STATUS_ALIASES[t] ?? t;
  const entry = MailDeliveryStatusDisplay[canonical];
  if (entry) {
    return {
      label: entry.label,
      iconVariant: entry.iconVariant,
      allowsManualResolve: Boolean(entry.allowsManualResolve)
    };
  }
  if (t.includes("blocked")) {
    const e = MailDeliveryStatusDisplay.blocked;
    return { label: e.label, iconVariant: e.iconVariant, allowsManualResolve: true };
  }
  if (t.includes("bounce")) {
    const e = MailDeliveryStatusDisplay.bounce;
    return { label: e.label, iconVariant: e.iconVariant, allowsManualResolve: true };
  }
  if (t.includes("defer")) {
    const e = MailDeliveryStatusDisplay.deferred;
    return { label: e.label, iconVariant: e.iconVariant, allowsManualResolve: true };
  }
  if (t.includes("drop")) {
    const e = MailDeliveryStatusDisplay.drop;
    return { label: e.label, iconVariant: e.iconVariant, allowsManualResolve: true };
  }
  if (t.includes("deliver")) {
    const e = MailDeliveryStatusDisplay.delivered;
    return { label: e.label, iconVariant: e.iconVariant, allowsManualResolve: false };
  }
  if (t.includes("process")) {
    const e = MailDeliveryStatusDisplay.processed;
    return { label: e.label, iconVariant: e.iconVariant, allowsManualResolve: false };
  }
  if (t === "open" || t.startsWith("open")) {
    const e = MailDeliveryStatusDisplay.open;
    return { label: e.label, iconVariant: e.iconVariant, allowsManualResolve: false };
  }
  return {
    label: String(rawStatus),
    iconVariant: null,
    allowsManualResolve: false
  };
};
